import { Injectable, ErrorHandler, Injector } from "@angular/core";
import { ApplicationInsightsService } from "./application-insights.service";

@Injectable()
export class ApplicationInsightsErrorHandler extends ErrorHandler {
    constructor(private injector: Injector) {
        super();
    }
    
    handleError(error: any) {
        const applicationInsightService = this.injector.get(ApplicationInsightsService);
        applicationInsightService.logError(error);
        super.handleError(error);
    }
}
